import { FormConfiguration } from '../../../containers/formConfiguration/index';

const SmsSettings = () => {
  return (
    <FormConfiguration configStartPrefix="TWILIO" pageTitle={'SMS Settings'} />
  );
};

export default SmsSettings;
